export default {
  name: "not-found-page",
  components: {},
  props: [],
  data() {
    return {
      logoImage: require("@/assets/image/NotFoundPage/Logo.svg"),
      ufoImage: require("@/assets/image/NotFoundPage/UFO.svg"),
      astronautImage: require("@/assets/image/NotFoundPage/Astronaut.svg"),
      excoinImage: require("@/assets/image/NotFoundPage/EXC.svg")
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
